import LogoImg from "@/../../public/images/pelorus-logo.svg";
import accesssystem from "@/../../public/images/Access-control-system.svg";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import AuthFooterScreen from "../../../component/layout/authfooter";
import { FaCheck } from "react-icons/fa6";
import { TbUserScan } from "react-icons/tb";
import { LuBuilding2 } from "react-icons/lu";

import { useLocation } from "react-router-dom";
import * as yup from "yup";
import { useCustomNavigate } from "../../../hooks/useCustomNavigate";
import { ValidationCons } from "../../../validation/validationConstant";
import { useFormik } from "formik";
import { showSuccess, showError } from "../../../utils/Common";
import { AppRoute } from "../../../router/routerConstants";
import { useState } from "react";
import { verifyUserApi, resendUserOTP } from "../../../service/apis/auth.api";

const VerifyYourAccountScreen = () => {
  const [NavigateTo] = useCustomNavigate();
  const [loading, setLoading] = useState(false);
  const { state } = useLocation();
  const location = useLocation();
  const empFormUrl = location.pathname.split("/")[1];
  const [isJobSeekerRegister] = useState(
    state?.role === "jobseeker" ? true : false
  );

  const resendOtp = async () => {
    const bodyData = { email: state.email };
    const response = await resendUserOTP(bodyData);
    showSuccess(response?.message);;
    
  };

  const registerStep3Formik = useFormik({
    initialValues: {
      otp: Array(6).fill(""),
    },
    validationSchema: yup.object({
      otp: yup
        .array()
        .of(
          yup.string().trim().length(1, ValidationCons.OTP_VERIFY) // Each character must be exactly 1 digit
          // .required(ValidationCons.OTP_VERIFY)
        )
        .length(6, ValidationCons.OTP_VERIFY),
    }),
    onSubmit: async (values: any) => {
      setLoading(true);
      if (values.otp.join("").length < 6) {
        showError(ValidationCons.OTP_VERIFY);
        return;
      }
      try {
        const bodyData = {
          email: state.email,
          otp: values.otp.join(""),
        };
        const response = await verifyUserApi(bodyData);

        if (response?.message === "OTP verified successfully") {
          if (state.role === "jobseeker") {
            showSuccess(response?.message);            
            NavigateTo(AppRoute.LOGIN, false, state);
          } else {
            showSuccess(response?.message);            
            if (empFormUrl === "emp") {
              NavigateTo(AppRoute.EMPLOYEE_REGISTER_STEP4, false, state);
            } else {
              NavigateTo(AppRoute.AGENT_REGISTER_STEP4, false, state);
            }
          }
          // setLoading(false);
        }
      } catch (error) {
        // setLoading(false);
        // showError(error);
      } finally {
        setLoading(false);
      }
    },
  });
  return (
    <>
      <header className="header common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="logo text-left">
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                  <img src={LogoImg} alt="logo" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="main-authModule">
        <section className="welcomebodylogin common-padd pb-0">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6 leftlargeImg">
                <img src={accesssystem} alt="logo" />
              </div>
              <div className="col-lg-6">
                <div className="welcome-holder">
                  <h1>Create an Account</h1>
                  <p>
                    Enter your personal details to create an account and start
                    journey with us.
                  </p>
                  <div className="login-form-area agent-steper verifyYouraccount-form mt-5">
                    <Form onSubmit={registerStep3Formik.handleSubmit}>
                      <div className="stepbar">
                        <ul>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 1</p>
                              <h4>Personal Info</h4>
                            </a>
                          </li>
                          <li className="checked">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <FaCheck />
                                </span>
                              </div>
                              <p>Step 2</p>
                              <h4>Password</h4>
                            </a>
                          </li>
                          <li className="inprogress">
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a>
                              <div className="icon-progress">
                                <span>
                                  <TbUserScan />
                                </span>
                              </div>
                              <p>Step 3</p>
                              <h4>Verification</h4>
                            </a>
                          </li>
                          {!isJobSeekerRegister && (
                            <li className="">
                              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                              <a>
                                <div className="icon-progress">
                                  <span>
                                    <LuBuilding2 />
                                  </span>
                                </div>
                                <p>Step 4</p>
                                <h4>
                                  {empFormUrl === "emp"
                                    ? "Company Info"
                                    : "Agent Info"}
                                </h4>
                              </a>
                            </li>
                          )}
                        </ul>
                      </div>
                      <h3>Verify Your Account</h3>
                      <p>
                        Enter the 6 digit verification code sent to your email.
                      </p>

                      {/* <p>Your code will expire in <span className="verificationcode">00:05</span></p> */}
                      <div className="verifyYouraccount mb-3">
                        {registerStep3Formik?.values &&
                          registerStep3Formik?.values?.otp &&
                          registerStep3Formik?.values?.otp.map(
                            (digit: string, index: number) => (
                              <Form.Group
                                key={index}
                                controlId={`Verify-number${index + 1}`}
                              >
                                <Form.Control
                                  type="text"
                                  placeholder="X"
                                  maxLength={1}
                                  value={digit}
                                  name={`otp[${index}]`}
                                  // onChange={registerStep3Formik.handleChange}

                                  onChange={(event) => {
                                    const value = event.target.value;
                                    if (/^\d?$/.test(value)) {
                                      // Allow only single digit
                                      registerStep3Formik.setFieldValue(
                                        `otp[${index}]`,
                                        value
                                      );

                                      // Move focus to the next input
                                      if (
                                        value &&
                                        index <
                                          registerStep3Formik.values.otp
                                            .length -
                                            1
                                      ) {
                                        const nextInput =
                                          document.querySelector<HTMLInputElement>(
                                            `input[name="otp[${index + 1}]"]`
                                          );
                                        nextInput?.focus();
                                      }
                                    }
                                  }}
                                  onKeyDown={(event) => {
                                    if (
                                      event.key === "Backspace" &&
                                      !digit &&
                                      index > 0
                                    ) {
                                      const prevInput =
                                        document.querySelector<HTMLInputElement>(
                                          `input[name="otp[${index - 1}]"]`
                                        );
                                      prevInput?.focus();
                                    }
                                  }}
                                  onPaste={(event) => {
                                    event.preventDefault();
                                    const pastedValue = event.clipboardData
                                      .getData("text")
                                      .trim();
                                    if (/^\d{6}$/.test(pastedValue)) {
                                      pastedValue
                                        .split("")
                                        .forEach((char, idx) => {
                                          if (
                                            idx <
                                            registerStep3Formik.values.otp
                                              .length
                                          ) {
                                            registerStep3Formik.setFieldValue(
                                              `otp[${idx}]`,
                                              char
                                            );
                                          }
                                        });

                                      const lastInput =
                                        document.querySelector<HTMLInputElement>(
                                          `input[name="otp[5]"]`
                                        );
                                      lastInput?.focus();
                                    }
                                  }}
                                  onBlur={registerStep3Formik.handleBlur}
                                />
                              </Form.Group>
                            )
                          )}
                      </div>

                      <div className="btn-holder d-flex mt-5">
                        {/* <Button className="btn btn-black w-100 btn-primary" variant="primary" type="submit">Back</Button> */}
                        <Button
                          className="btn w-100 btn-primary"
                          variant="primary"
                          type="submit"
                        >
                          {loading ? "Verifying ..." : "Verify Now"}
                        </Button>
                      </div>
                      <div className="register-now mt-3">
                        <p>
                          Didn't receive a code?{" "}
                          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                          <a onClick={resendOtp}> Resend Code</a>
                        </p>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AuthFooterScreen />
    </>
  );
};
export default VerifyYourAccountScreen;
